import React, { useState, useRef, useEffect } from "react";
import useVoiceRecorder from "../hooks/useVoiceRecorder";
import { sendMessage } from "../services/api";
import audioPlayer from "../services/audioPlayer";
import "./VoiceControls.css";

const VoiceControls = ({ sessionId, onTranscript, disabled }) => {
  const { isRecording, startRecording, stopRecording } = useVoiceRecorder();
  const [isProcessing, setIsProcessing] = useState(false);
  const [isVoiceMode, setIsVoiceMode] = useState(false);
  const conversationRef = useRef(false);

  const handleClick = async () => {
    if (disabled || isProcessing) return;

    if (!isVoiceMode) {
      setIsVoiceMode(true);
      conversationRef.current = true;
      startRecording();
    } else if (isRecording) {
      setIsProcessing(true);
      const text = await stopRecording();
      
      if (text && text.length > 2) {
        onTranscript(text);
        try {
          const result = await sendMessage(text, sessionId);
          if (result.success && result.response) {
            audioPlayer.playText(result.response);
          }
        } catch (e) {
          console.log("Voice send failed:", e);
        }
      }
      
      setIsProcessing(false);
      if (conversationRef.current) {
        setTimeout(function() {
          if (conversationRef.current) startRecording();
        }, 1500);
      }
    }
  };

  const stopVoiceMode = () => {
    conversationRef.current = false;
    setIsVoiceMode(false);
    if (isRecording) stopRecording();
    audioPlayer.stop();
  };

  useEffect(() => {
    return () => { conversationRef.current = false; };
  }, []);

  return (
    <div className="voice-controls">
      <button
        className={"voice-btn " + (isVoiceMode ? "voice-active" : "") + (isRecording ? "recording" : "") + (isProcessing ? "processing" : "")}
        onClick={handleClick}
        disabled={disabled || isProcessing}
        title={isVoiceMode ? (isRecording ? "Listening... click to stop" : "Voice mode active") : "Start voice conversation"}
      >
        {isProcessing ? <i className="fas fa-spinner fa-spin"></i> :
         isRecording ? <i className="fas fa-microphone-alt"></i> :
         isVoiceMode ? <i className="fas fa-microphone"></i> :
         <i className="fas fa-microphone"></i>}
      </button>
      {isVoiceMode && (
        <button className="voice-stop-btn" onClick={stopVoiceMode} title="End voice mode">
          <i className="fas fa-times"></i>
        </button>
      )}
      {isRecording && <span className="recording-label">REC</span>}
    </div>
  );
};

export default VoiceControls;
